import React from 'react';
import { LanguageSelect } from '@components/LanguageSelect';
import { Language } from '@type/common';
import './LanguageSelector.scss';

interface LanguageSelectorProps {
  languages: Language[];
}

export const LanguageSelectorMobile = ({ languages }: LanguageSelectorProps) => {
  const currentLanguageTitle = () => {
    const lang = languages?.filter((i) => i.LanguageCode == window.lang);
    if (lang.length > 0) {
      return lang[0].Name;
    } else {
      return languages[0].Name;
    }
  };

  const languageTitle = currentLanguageTitle();

  const select = (item: Language) => {
    window.location.href = item.Href;
  };

  return (
    <div className='c-header-language-selector-mobile'>
      <LanguageSelect
        list={languages}
        name='Name'
        title={languageTitle}
        selectFunction={(item) => select(item)}
      />
    </div>
  );
};
